import { useContext, useState } from 'react';
import FormContext from 'context/ContactForm';
import styled from '@emotion/styled';
import { LuX } from 'react-icons/lu';

const TextareaContainer = styled.div`
  position: relative;
`;

const StyledTextarea = styled.textarea`
  ${({ theme }) => theme.mixins.Body};
  resize: none;
  background: transparent;
  outline: none;
  color: ${({ theme }) => theme.colors.white};
  width: 100%;
  height: 100%;
  padding: 1rem;
  padding-right: 6rem;
  min-height: 18rem;
  border: none;
  border-top: 1px solid ${({ theme }) => theme.colors.gray};

  &:focus + label {
    display: none;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    &:hover + label {
      color: ${({ theme }) => theme.colors.gray};
    }
  }

  :not(input:-webkit-autofill)::-webkit-contacts-auto-fill-button {
    background-color: ${({ theme }) => theme.colors.gray};
    position: absolute;
  }
`;

const StyledLabel = styled.label`
  all: unset;
  ${({ theme }) => theme.mixins.Body};
  position: absolute;
  color: ${({ theme }) => theme.colors.white};
  margin: 1rem;
  left: 0;
  transition: color 0.3s ease;
`;

const ClearButton = styled.button`
  all: unset;
  position: absolute;
  top: 0;
  right: 0;
  margin: 1rem;

  &:hover {
    color: ${({ theme }) => theme.colors.accent};
    cursor: pointer;
  }

  svg {
    font-size: 1.8rem;
  }
`;

const CharacterCount = styled.p`
  ${({ theme }) => theme.mixins.MonoM};
  color: ${({ theme }) => theme.colors.gray};
  font-size: 1.2rem;
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 1rem;
  pointer-events: none;
`;

const FormTextArea = ({
  name,
  label,
  required,
  showClearButton = true,
  maxLength = 200,
}) => {
  const { formData, updateFormData } = useContext(FormContext);
  const [isFocused, setIsFocused] = useState(false);

  const value = formData[name] || '';

  const textareaId = `textarea-${label.replace(/\s+/g, '-').toLowerCase()}`;

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  const handleChange = (e) => {
    updateFormData(name, e.target.value);
  };

  const handleClear = () => updateFormData(name, '');

  return (
    <TextareaContainer>
      <StyledTextarea
        id={textareaId}
        name={name}
        value={value}
        required={required}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        aria-labelledby={`${textareaId}-label`}
        maxLength={maxLength}
      />
      {!value && (
        <StyledLabel id={`${textareaId}-label`} htmlFor={textareaId}>
          {label}
        </StyledLabel>
      )}
      {showClearButton && value && (
        <ClearButton
          type="button"
          onClick={handleClear}
          aria-label={`Clear ${label}`}
          isFocusedOrFilled={isFocused || value}
        >
          <LuX />
        </ClearButton>
      )}
      <CharacterCount>{`${value.length}/${maxLength}`}</CharacterCount>
    </TextareaContainer>
  );
};
export default FormTextArea;
